<mat-card appearance="outlined">
    <section>
      <mat-tab-group dynamicHeight [(selectedIndex)]="currentTab">
  
        <mat-tab label="Re-License Labs" *ngIf="tabVisible('reLicenseLabs')">
          <app-reLicenseLabs></app-reLicenseLabs>
        </mat-tab>

        <mat-tab label="Print Renewal Forms" *ngIf="tabVisible('printRenewalForms')">
          <app-printRenewalForms></app-printRenewalForms>
        </mat-tab>
  
        <mat-tab label="Print Lab Licenses" *ngIf="tabVisible('printLabLicense')">
          <app-printLabLicense></app-printLabLicense>
        </mat-tab>
    
      </mat-tab-group>
    </section>
  </mat-card>